import { jsx as r } from "react/jsx-runtime";
import { C as E, s as T, F as b, t as N, v as x, w as I, x as F, y as H, z as M } from "./helpers-458d7e27.js";
import { TopUpIcon as z } from "@paypalcorp/pp-react-icons";
import h from "clsx";
import { useContext as D, useState as R, useEffect as V } from "react";
import "@emotion/react";
import "@paypalcorp/pp-react-theme";
import "react-dom";
const S = () => {
  var t;
  (t = document.getElementById("scroll-sticky-button")) == null || t.blur();
}, Y = ({
  prefersReducedMotion: t = !0,
  smoothScrollEnabled: e = !0
}) => e ? t ? "instant" : "smooth" : "instant", j = ({
  scrollBehavior: t,
  elementId: e
}) => {
  const o = document.getElementById(e);
  o && (o.scrollIntoView({
    behavior: t
  }), S());
}, q = ({
  scrollBehavior: t
}) => {
  let e = 0;
  const o = document.getElementById("globalnav-header") || document.querySelector(".pp-header");
  if (o) {
    const { height: l } = getComputedStyle(o), [s] = l.split("px");
    e = Number(s);
  }
  window.scrollTo({
    top: e,
    behavior: t
  }), S();
};
const i = "ScrollStickyButton", p = new E(i), A = ({
  className: t,
  ariaLabel: e,
  targetElementId: o,
  smoothScroll: l = !0,
  serverFptiData: s
}) => {
  const { environment: { pageSegment: f = "" } = {} } = T(), { foundationTheme: g } = D(b), [n, a] = R(!1), k = N(), m = Y({
    prefersReducedMotion: k,
    smoothScrollEnabled: l
  });
  V(() => {
    const u = M(() => {
      const d = document.body.clientHeight || 290;
      !n && window.scrollY > d ? a(!0) : n && window.scrollY <= d && a(!1);
    }, 50);
    return window.addEventListener("scroll", u), () => {
      window.removeEventListener("scroll", u);
    };
  }, [n]);
  const v = () => {
    !!o ? j({ scrollBehavior: m, elementId: o }) : q({ scrollBehavior: m });
  }, w = (c) => {
    c.preventDefault();
  }, C = h(
    p.getElementClassName("container"),
    g
  ), y = h(p.getComponentClassName(), t), B = x(
    {
      componentName: i,
      linkText: e,
      linkSection: "Container",
      clickEvent: F.ScrollTopButton,
      serverFptiData: s
    },
    f,
    I.Button
  );
  return /* @__PURE__ */ r("div", { className: C, children: n && /* @__PURE__ */ r(
    H,
    {
      id: "scroll-sticky-button",
      className: y,
      "aria-label": e,
      "data-pa-click": B,
      size: "sm",
      onClick: v,
      onMouseDown: w,
      "pa-marked": "1",
      children: /* @__PURE__ */ r(z, { size: "sm" })
    }
  ) });
};
A.displayName = i;
export {
  A as default
};
//# sourceMappingURL=ScrollStickyButton.js.map
